module.exports = __webpack_public_path__ + "static/payments-a69f6d5dcc5659f2972a4dfebc7922de.jpg";